// S4 : renouvellement silencieux de l'access token (single-flight).
// Un seul appel /api/auth/refresh même si plusieurs requêtes tombent en 401 simultanément.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let refreshPromise = null;

export function refreshSession() {
  // Pas de refresh pendant une impersonation (token distinct, géré séparément).
  try {
    if (window.sessionStorage?.getItem('impersonate_token')) {
      return Promise.resolve(null);
    }
  } catch {
    // sessionStorage inaccessible (mode privé) -> on continue
  }

  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      // Utiliser le fetch original pour ne PAS repasser par l'intercepteur (anti-boucle).
      const rawFetch = (window.fetch && window.fetch.__originalFetch) || window.fetch;
      const res = await rawFetch(`${BACKEND_URL}/api/auth/refresh`, {
        method: 'POST',
        credentials: 'include',
      });
      if (!res.ok) return null;
      const data = await res.json();
      if (data && data.access_token) {
        try { window.localStorage.setItem('token', data.access_token); } catch { /* ignore */ }
        return data.access_token;
      }
      return null;
    } catch {
      return null;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
